import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled.div`
  text-align: right;
`

export const Text = styled.span`
  font-size: 10px;
`

export const badge = css`
  margin: 0 3px;
`

export const icon = css`
  font-size: 14px;
`
